import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { AnalyticsStore, ExperimentStore } from 'bernie-core';
import { LocalizedComponentProps, withLocalization } from 'bernie-l10n';

import { CurrentHotelStore } from 'stores/current-hotel-store';
import { mapProperty } from 'src/common/stores/adapters';
import { SearchResultsStore } from 'stores/search-results-store';
import { ShortlistStore } from 'stores/shortlist-store';

import { MapSheet } from 'components/common/map/sheets/map-sheet';
import { PropertyFields } from 'src/common/__generated__/api';

export interface DynamicSheetProps {
  analytics?: AnalyticsStore;
  selectedHotel: PropertyFields.Fragment;
  selectedMarker: any;
  shortlist?: ShortlistStore;
  experiment?: ExperimentStore;
  searchResults?: SearchResultsStore;
  currentHotel?: CurrentHotelStore;
  onFavoriteClick: () => void;
}

export type LocalizedDynamicSheetProps = LocalizedComponentProps & DynamicSheetProps;

@withLocalization
@inject('routeStore', 'analytics', 'searchResults', 'shortlist', 'experiment', 'currentHotel')
@observer
export class DynamicSheet extends React.Component<LocalizedDynamicSheetProps> {
  public render() {
    const { l10n, onFavoriteClick, selectedMarker, selectedHotel } = this.props;

    if (!selectedHotel || !selectedMarker || !selectedMarker.sheet) {
      return null;
    }

    return (
      <MapSheet
        sheet={selectedMarker.sheet}
        isVisible={true}
        onClick={this.onSheetClick}
        onFavoriteClick={onFavoriteClick}
        selectedHotel={mapProperty(selectedHotel)}
        l10n={l10n}
      />
    );
  }

  private onSheetClick = () => {
    const { searchResults, selectedHotel, selectedMarker } = this.props;

    let selected = selectedHotel;
    if (selectedMarker.sheet?.id) {
      const foundHotel = searchResults.findProperty(selectedMarker.sheet.id.toString(), selectedMarker.sheet.travelAd);

      if (foundHotel) {
        selected = foundHotel;
      }
    }

    this.props.currentHotel.setPropertyListingAsCurrentHotel(selected);
  };
}
